<template>
  <v-container
    :fill-height="smAndUp"
    class="min-width-available"
    align-start
  >
    <div class="min-width-available">
      <v-layout wrap justify-center :class="mdAndUp ? 'mt-10' : 'mt-5'" class="min-width-available">
        <!-- DESKTOP LEFT COLUMN -->
        <v-flex xs12 v-if="isBookingDisabled && mdAndUp">
          <v-layout justify-center class="flex-none">
            <v-alert :value="true" type="warning" class="mb-8">
              {{ $t('main.booking_disabled') }}
            </v-alert>
          </v-layout>
        </v-flex>
        <v-flex v-if="mdAndUp"
          xs4
          class="px-5"
          :class="{
            'pl-14 pr-20': xlAndUp
          }"
        >
          <div class="headline font-weight-medium primary--text">
            {{ $t('main.checkin_date') }}
          </div>
          <div class="date" v-if="checkin">
            {{ checkin }}
          </div>
          <p class="nick-title">
            {{ $t('main.visitors') }}
          </p>
          <v-divider class="mb-2" />
          <v-divider class="mb-10" />
          <v-layout justify-center v-if="state.loading">
            <v-progress-circular indeterminate color="accent" />
          </v-layout>
          <guest-buttons v-else />
        </v-flex>
        <!-- DESKTOP RIGHT COLUMN / MOBILE -->
        <v-flex xs12 md7 :class="mdAndUp ? 'max-width-600 ml-3' : ''">
          <v-layout column >
            <v-layout column :align-center="smAndDown">
              <v-layout v-if="isBookingDisabled && smAndDown" justify-center class="flex-none">
                <v-alert :value="true" type="warning" class="mb-8">
                  {{ $t('main.booking_disabled') }}
                </v-alert>
              </v-layout>
              <template v-if="smAndDown">
                <div class="headline font-weight-medium primary--text">
                  {{ $t('main.checkin_date') }}
                </div>
                <div class="date mb-4" v-if="checkin">
                  {{ checkin }}
                </div>
              </template>
              <div
                class="image-div uppercase"
                :style="{ backgroundImage: `url(${require('@/assets/NHR_TK_Photo_003.jpg')})` }"
                @click="openInNewTab(externalLinks.karisma)">
                <span :class="{ 'display-3': smAndUp, 'display-1': xsOnly }" class="px-2">{{ $t('main.website') }}</span>
              </div>
              <div v-if="!isBookingDisabled"
                class="image-div uppercase mt-10"
                :style="{ backgroundImage: `url(${require('@/assets/NHR_TK_Photo_010.jpg')})` }"
                @click="$router.push({ name: routeNames.catalog.name })"
                :class="{
                  'mb-6': mdAndDown
                }">
                <span :class="{ 'display-2': smAndUp, 'display-1': xsOnly }" class="px-2">{{ $t('main.buy_packages') }}</span>
              </div>
            </v-layout>
            <guest-buttons v-if="smAndDown" />
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import routeNames from '@/router/routes'
import moment from 'moment'
import { externalLinks } from '@/config'
import { mapGetters, mapState } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'
import routingMixins from '@/mixins/Routing'

export default {
  data () {
    return {
      moment,
      routeNames,
      externalLinks
    }
  },
  computed: {
    ...mapState(['state', 'bookings']),
    ...mapGetters({
      isBookingDisabled: 'bookings/isBookingDisabled'
    }),
    checkin () {
      const checkin = this.bookings.read && this.bookings.read.booking ? this.bookings.read.booking.checkin : null
      return checkin ? moment(checkin).format('DD/MM/YYYY') : null
    }
  },
  created () {
    this.$store.dispatch('bookings/get')
  },
  components: {
    GuestButtons: () => import('@/components/view-components/buttons/GuestButtons.vue')
  },
  mixins: [
    vuetifyMixins,
    routingMixins
  ]
}
</script>

<style scoped lang="scss">
.date {
  font-size: 23px;
  color: #392F2C;
}
.image-div {
  height: 180px;
  border-radius: 6px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  display: flex;
  text-align: center;
  & span {
    margin: auto;
    font-weight: bold;
    color: white;
  }
  @media (max-width: 1249px) {
    background-size: 134%;
    min-width: 100%;
    max-width: 100%;
  }
  @media (min-width: 1250px) {
    background-size: cover;
    min-width: 600px;
  }
}
</style>
